// src/services/tenantSettings/tenantSettingsService.js
import axios from '../axiosInstance';

/** Query key for React Query cache (use everywhere for tenant settings). */
export const TENANT_SETTINGS_QUERY_KEY = ['tenantSettings'];

/**
 * Fetch tenant settings from the API. Use for prefetch on login and for useTenantSettings.
 * @returns {Promise<object>} Full tenant settings object (e.g. { weighingConsoleLookupDisplay, commodityFilterByAccount, ... })
 */
export async function getTenantSettings(signal = null) {
    const { data } = await axios.get('tenant-settings/settings', { signal });
    return data;
}

/**
 * Update tenant settings (partial merge). Backend should merge patch into existing settings.
 * @param {object} patch - e.g. { weighingConsoleLookupDisplay: { account: { primary: 'name', secondary: 'erpCode' } } }
 */
export async function updateTenantSettings(patch, signal = null) {
    const { data } = await axios.patch('tenant-settings/settings', patch, { signal });
    return data;
}

/** Login-page settings (anonymous; tenant resolved from host). */
export async function getLoginTenantSettings(signal = null) {
    const { data } = await axios.get('tenant-settings/login-config', { signal });
    return data;
}
